// test1975
(1975 && 0);
